<template lang="pug" >
  div
    div.kpi-cardsC__conteotext
      span.kpi-cardsC__conteo {{ ammount }}
    div.kpi-cardsC__title(slot='title' v-if="color")
      div.kpi-cardsC__square
        div.kpi-cardsC__square-content(:style="{'background-color': color ? color : 'transparent'}")
      span.kpi-cardsC__square-text {{ title }}
    div.kpi-cardsC__title(slot='title' v-else)
      span.kpi-cardsC__square-text {{ title }}
    div.barformat
      ods-progress(
        v-if='color'
        :percentage='percentage'
        :color='color'
        :show-text='false'
        :width='parseInt(percentage)')
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    ammount: {
      type: String,
      required: true
    },
    percentage: {
      required: false
    },
    color: {
      required: false
    }
  },
  name: 'KpiCards'
}
</script>

<style lang="scss">
</style>
